var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.75a6.183 6.183 0 00-5.848 8.2v.01l.009.018c.105.296.231.582.376.856l.003.006.003.006c.059.108.12.216.185.32l.006.01.003.006 4.098 7.086c.518.893 1.81.893 2.324 0l4.116-7.108.018-.027.133-.231a.124.124 0 00.015-.028l.004-.01.003-.005a6.46 6.46 0 00.391-.884l.01-.018v-.007c.218-.634.338-1.314.338-2.022 0-3.41-2.771-6.178-6.187-6.178zm0 8.924A2.935 2.935 0 018.062 8.74 2.937 2.937 0 0111 5.807a2.937 2.937 0 012.938 2.933A2.937 2.937 0 0111 11.674z",
    fill: "#595959"
  })));
}
export default SvgAddress;